"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPT_CODE_EXPIRE_TIME_Mil_SC = exports.OPT_CODE_LENGTH = void 0;
exports.OPT_CODE_LENGTH = 6;
exports.OPT_CODE_EXPIRE_TIME_Mil_SC = 5 * 60 * 1000; // 5 minutes
//# sourceMappingURL=opt.js.map